module.exports = __webpack_public_path__ + "static/media/IMG_0841.effe3ddc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/肉桂捲/IMG_0841.JPG
// module id = 861
// module chunks = 0